module.exports = __webpack_public_path__ + "img/main_2_2_2_2_2.ecea03e6.png";